import { Box } from '@mui/material';
import { FunctionComponent } from 'react';
import { Loader } from '../../../ui/components';

export const RedirectPage: FunctionComponent = () => {
  return <Box
    sx={{
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Loader loading={true} />
  </Box>;
};
